const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.mov', '.m4v', '.mkv'] as const

/** True if the storage/file name looks like a video (Firebase listing uses object names). */
export function isVideoFileName(name: string): boolean {
  const lower = name.toLowerCase()
  return VIDEO_EXTENSIONS.some(ext => lower.endsWith(ext))
}

export function isVideoMimeType(mime: string): boolean {
  return mime.toLowerCase().startsWith('video/')
}

export function isVideoFile(file: File): boolean {
  if (file.type && isVideoMimeType(file.type)) return true
  return isVideoFileName(file.name)
}
